/* Iconic — 3-box collection filters with era grouping. */
(function () {
  'use strict';

  /* Era mapping: set tag -> era group, per game. Sets not listed fall into "More". */
  /* Sets listed in RELEASE ORDER (newest first) within each era. */
  var ERAS = {
    'Pokémon': [
      { label: 'Mega Evolution Series (2025–26)', sets: ['30th Celebration', 'Mega Evolution: Pitch Black', 'Mega Evolution: Chaos Rising', 'Mega Evolution: Perfect Order', 'Mega Evolution: Ascended Heroes', 'Mega Evolution: Phantasmal Flames', 'Mega Evolution'] },
      { label: 'Scarlet & Violet Series (2023–25)', sets: ['Black Bolt', 'White Flare', 'Destined Rivals', 'Journey Together', 'Prismatic Evolutions', 'Surging Sparks', 'Stellar Crown', 'Shrouded Fable', 'Twilight Masquerade', 'Temporal Forces', 'Paldean Fates', 'Paradox Rift', '151', 'Obsidian Flames', 'Paldea Evolved', 'Scarlet & Violet Base'] },
      { label: 'Sword & Shield Series (2020–22)', sets: ['Crown Zenith', 'Silver Tempest', 'Lost Origin', 'Pokémon GO', 'Astral Radiance', 'Brilliant Stars', 'Fusion Strike', 'Celebrations', 'Evolving Skies', 'Chilling Reign', 'Battle Styles', 'Shining Fates', 'Vivid Voltage', "Champion's Path", 'Darkness Ablaze', 'Rebel Clash', 'Sword & Shield Base'] },
      { label: 'Classic sets', sets: ['Shining Legends', 'Burning Shadows', 'Primal Clash'] },
      { label: 'Seasonal & special', sets: ['Seasonal & Special Releases'] },
      { label: 'Ranges & collections', sets: ['ex Boxes & Premium Collections', 'Battle Decks & Championship Decks', 'Azure Legends Tins', 'Kanto Friends Mini Tins', 'Mega Heroes Mini Tins', 'Sinnoh Stars Mini Tins', 'Vibrant Paldea Mini Tins', 'Stacking Tins'] }
    ],
    'One Piece': [
      { label: 'Latest sets', sets: ['The Time of Battle (OP-16)', "Adventure on Kami's Island (OP-15)", 'The Azure Sea Pirates (OP-14)', 'Carrying On His Will (OP-13)'] },
      { label: 'OP-01 – OP-12', sets: ['Legacy of the Master (OP-12)', 'A Fist of Divine Speed (OP-11)', 'Royal Blood (OP-10)', 'Emperors in the New World (OP-09)', 'Two Legends (OP-08)', '500 Years in the Future (OP-07)', 'Wings of the Captain (OP-06)', 'Awakening of the New Era (OP-05)', 'Kingdoms of Intrigue (OP-04)', 'Pillars of Strength (OP-03)', 'Paramount War (OP-02)', 'Romance Dawn (OP-01)'] },
      { label: 'Extra & premium', sets: ['EB / Extra Boosters', 'PRB / Premium Boosters'] }
    ],
    'Magic: The Gathering': [
      { label: 'Universes Beyond', sets: ['Universes Beyond: Final Fantasy', 'Universes Beyond: Avatar The Last Airbender', "Universes Beyond: Marvel's Spider-Man", 'Marvel Super Heroes', 'Teenage Mutant Ninja Turtles'] },
      { label: 'Magic sets', sets: ['Lorwyn Eclipsed', 'Secrets of Strixhaven', 'Edge of Eternities', 'Bloomburrow', 'Duskmourn', 'Aetherdrift', 'Tarkir: Dragonstorm'] }
    ],
    'Disney Lorcana': [
      { label: 'Current sets', sets: ['Attack of the Vine', 'Wilds Unknown', 'Winterspell', 'Whispers in the Well'] },
      { label: 'Earlier chapters', sets: ['Fabled', 'Reign of Jafar', "Archazia's Island", 'Azurite Sea', 'Shimmering Skies', 'Ursula’s Return', 'Into the Inklands', 'Rise of the Floodborn', 'The First Chapter'] }
    ]
  };

  function isJapanese(tag) { return /\(Japanese\)$/.test(tag); }
  function isKorean(tag) { return /\(Korean\)$/.test(tag); }

  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    var game = form.getAttribute('data-game') || '';
    var collectionUrl = form.getAttribute('data-collection-url');
    var setSelect = form.querySelector('select[data-group="set"]');

    /* Group the set <options> into era <optgroup>s */
    if (setSelect) {
      var options = [].slice.call(setSelect.querySelectorAll('option[value]')).filter(function (o) { return o.value; });
      var eras = ERAS[game] || [];
      if (options.length > 6) {
        var placed = {};
        var groups = [];
        eras.forEach(function (era) {
          var members = options.filter(function (o) { return era.sets.indexOf(o.getAttribute('data-tag')) !== -1; });
          members.sort(function (a, b) {
            return era.sets.indexOf(a.getAttribute('data-tag')) - era.sets.indexOf(b.getAttribute('data-tag'));
          });
          members.forEach(function (o) { placed[o.getAttribute('data-tag')] = true; });
          if (members.length) groups.push({ label: era.label, options: members });
        });
        var jp = options.filter(function (o) { return !placed[o.getAttribute('data-tag')] && isJapanese(o.getAttribute('data-tag')); });
        var kr = options.filter(function (o) { return !placed[o.getAttribute('data-tag')] && isKorean(o.getAttribute('data-tag')); });
        jp.forEach(function (o) { placed[o.getAttribute('data-tag')] = true; });
        kr.forEach(function (o) { placed[o.getAttribute('data-tag')] = true; });
        if (jp.length) groups.push({ label: 'Japanese sets', options: jp });
        if (kr.length) groups.push({ label: 'Korean sets', options: kr });
        var rest = options.filter(function (o) { return !placed[o.getAttribute('data-tag')]; });
        if (rest.length) groups.push({ label: groups.length ? 'More sets & ranges' : 'Sets', options: rest });

        var keep = setSelect.querySelector('option:not([value]), option[value=""]');
        setSelect.innerHTML = '';
        if (keep) setSelect.appendChild(keep);
        groups.forEach(function (g) {
          var og = document.createElement('optgroup');
          og.label = g.label;
          g.options.forEach(function (o) { og.appendChild(o); });
          setSelect.appendChild(og);
        });
      }
    }

    /* Navigate on change: combine the three boxes into a tag-filter URL */
    form.addEventListener('change', function () {
      var handles = [];
      form.querySelectorAll('select[data-group]').forEach(function (sel) {
        if (sel.value) handles.push(sel.value);
      });
      var url = collectionUrl;
      if (handles.length) url += '/' + handles.join('+');
      var sort = new URLSearchParams(window.location.search).get('sort_by');
      if (sort) url += '?sort_by=' + encodeURIComponent(sort);
      window.location.href = url;
    });
  });
})();
